import "./AboutUs.css";

import * as React from "react";

interface IAboutUsProps {}

interface IAboutUsState {}

export default class AboutUs extends React.Component<IAboutUsProps, IAboutUsState> {

    public constructor(props: IAboutUsProps) {
        super(props);
    }

    public render() {
        return (
            <div className="AboutUs">
                <img src="assets/images/treppe_herzweg.png" className="AboutUs__image"/>
                <p>
                    Eigentlich hatten wir im Sommer 2015 nur ein Essen unter neuen Freunden geplant,
                    als wir überraschend feststellten, dass uns nicht nur menschlich, sondern auch
                    musikalisch eine Menge verbindet.
                </p>
                <p>
                    Wir trafen uns mit wachsender Begeisterung immer häufiger zum Musik machen. In meist nächtlichen
                    Jam-Sessions entstanden dabei sofort ganz eigene Texte und Melodien unterschiedlichster Klangfarben
                    und Musikstile.
                </p>
                <p>
                    Drei Jahre später können wir uns immer noch nicht auf eine Definition unserer musikalischen
                    Verbindung festlegen. Was wir machen? Singer-Songwriter, Rap und Pop. Meistens auf Deutsch, oft
                    zweistimmig gesungen, häufig mit Klavier, Gitarre oder Synthesizer.
                </p>
                <p>
                    Viel Spaß beim Hören und Stöbern auf unserer Seite - meldet Euch gerne bei Interesse oder
                    Fragen bei uns.
                </p>
                <img src="assets/images/boje_herzweg.png" className="AboutUs__image"/>
                <p className="AboutUs__names">
                    <span>NORMA JEAN</span><span> & TIM</span>
                </p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AboutUs.tsx